module.exports = __webpack_public_path__ + "img/img08.dd046dcb.png";